module.exports = __webpack_public_path__ + "static/media/usaid.2b56c7df.svg";